import { httpClient } from "@services/api/httpClient";

interface GetOverviewParams {
  page: string | number;
  itemsPerPage: string | number;
  status?: "OPEN" | "CLOSED";
}

export async function getOfferOverview({ page, itemsPerPage, status }: GetOverviewParams) {
  const response = await httpClient.get("/offer/overview", {
    params: { page, itemsPerPage, status }
  });
  return response.data;
}